import { SocialProvider } from '../types/auth';

function readCleanUtmParamsFromStorage(): Record<string, string> {
  const utmParams: Record<string, string | null> = {
    utm_source: localStorage.getItem('utm_source'),
    utm_medium: localStorage.getItem('utm_medium'),
    utm_campaign: localStorage.getItem('utm_campaign'),
    utm_content: localStorage.getItem('utm_content'),
    utm_term: localStorage.getItem('utm_term'),
    ad_id: localStorage.getItem('ad_id'),
    fbc_id: localStorage.getItem('fbc_id'),
    h_ad_id: localStorage.getItem('h_ad_id'),
    utm_id: localStorage.getItem('utm_id'),
    gc_id: localStorage.getItem('gc_id'),
    h_ga_id: localStorage.getItem('h_ga_id'),
    h_keyword_id: localStorage.getItem('h_keyword_id'),
    h_keyword: localStorage.getItem('h_keyword'),
    h_placement: localStorage.getItem('h_placement'),
    g_special_campaign: localStorage.getItem('g_special_campaign'),
  };

  return Object.entries(utmParams)
    .filter(([, value]) => value !== null && value !== undefined && value.trim() !== '')
    .reduce<Record<string, string>>((acc, [key, value]) => {
      acc[key] = value!.trim();
      return acc;
    }, {});
}

export type BuildSsoOAuthStateOptions = {
  provider: SocialProvider;
  planIdParam: string | null;
  flow: string;
  usePreSignupFlow?: boolean;
  isRegistration?: boolean;
  popupFlow?: boolean;
};

/**
 * OAuth `state` JSON for Cognito Hosted UI (full redirect or popup flow).
 */
export function buildSsoOAuthStateString(options: BuildSsoOAuthStateOptions): string {
  const cleanUtmParams = readCleanUtmParamsFromStorage();
  const stateData = {
    isRegistration: options.isRegistration ?? true,
    timestamp: Date.now(),
    flow: options.flow,
    provider: options.provider,
    usePreSignupFlow: options.usePreSignupFlow ?? false,
    popupFlow: options.popupFlow ?? false,
    ...(options.planIdParam && { planId: options.planIdParam }),
    ...(Object.keys(cleanUtmParams).length > 0 && { utm_params: cleanUtmParams }),
  };
  return JSON.stringify(stateData);
}
